export default __webpack_public_path__ + "locales/it/PaymentsEnterprise.json?hash=5c10b593683ddab5b15d2f9cbb6146f8";